var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ct-map"},[_c('GMap',{ref:"gMap",attrs:{"language":"en","center":{
      lat: parseFloat(_vm.lat),
      lng: parseFloat(_vm.lng)
    },"options":{
      fullscreenControl: false,
      styles: _vm.mapstyle,
      zoomControl: false,
      mapTypeControl: false
    },"zoom":14}},[_c('GMapMarker',{attrs:{"position":{
        lat: _vm.lat,
        lng: _vm.lng
      },"options":{
        icon: {
          url: require('~/assets/icons/pin.svg'),
          scaledSize: {
            height: 70,
            width: 70
          }
        }
      }},on:{"click":_vm.linkToMaps}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }